var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.63178 1.70228C7.32518 0.501265 9.0587 0.501268 9.7521 1.70228L15.9928 12.5114C16.6862 13.7124 15.8194 15.2137 14.4326 15.2137L1.95128 15.2137C0.564472 15.2137 -0.302282 13.7124 0.391124 12.5114L6.63178 1.70228Z",
    fill: "#FFBC07"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.c9639b9114df6d7647a37bbe3dd3ea16.svg";
export { ForwardRef as ReactComponent };